import Vue from 'vue'
import App from './App.vue'
import router from './router/routes'
import store from './store'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'

import './assets/css/_colors.sass'

import { setContext } from '@apollo/client/link/context'

import Vuelidate from 'vuelidate'

import vue_fb from '@/plugins/fb-sdk'

Sentry.init({
    Vue,
    dsn: 'https://7fdd66c4b6434deea4e439817a3840e1@o439320.ingest.sentry.io/6092522',
    integrations: [
        new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: [
                'localhost',
                'https://business.partymate.io/',
                'https://business-staging.partymate.io',
                /^\//,
            ],
        }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
})

Vue.use(vue_fb, {
    appId: process.env.VUE_APP_FACEBOOK_CLIENT_KEY,
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v12.0',
})

Vue.use(Vuelidate)

Vue.prototype.$pm = {}

const cache = new InMemoryCache()

if (!process.env.VUE_APP_API_URL || !process.env.VUE_APP_API_KEY) {
    alert('API URL or API KEY was not set.')
    console.error('API URL or API KEY was not set.')
}

const httpLink = createHttpLink({
    uri: process.env.VUE_APP_API_URL,
})

const authLink = setContext((_, { headers }) => {
    // get the authentication token from vuex if it exists
    const token = store.getters.token ? store.getters.token : ''
    // return the headers to the context so httpLink can read themx
    return {
        headers: {
            ...headers,
            'api-key': process.env.VUE_APP_API_KEY,
            authorization: token ? `${token}` : '',
        },
    }
})

const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
})

const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
})

Vue.use(VueApollo)
Vue.config.productionTip = false

import { i18n } from '@/locales/i18n'

window.v = new Vue({
    router,
    store,
    i18n,
    metaInfo: () => ({
        meta: [
            {
                name: 'viewport',
                content: 'width=device-width, initial-scale=1.0, user-scalable=no',
                vmid: 'userscalable',
            },
        ],
    }),
    apolloProvider,
    render: (h) => h(App),
}).$mount('#app')
